import React from "react";
import { TaleText } from "@components/TaleText";
import { TaleLoadingFallback } from "./TaleLoadingFallback";
import { isCompanyUser } from "@/utils/roleStorage";

function TaleButton({
  role ,
  variant = "filled",
  onClick = () => undefined,
  className = "",
  children,
  Component = "button",
  directParentClassName = "",
  loading = false,
  loadingCircleSize = 25,
  ...props
}) {
  const resolvedRole = role ?? (isCompanyUser() ? "business" : "normal");

  const buttonStyle = {
    height: "51px",
    color: "white",
    textAlign: "center",
    lineHeight: "19px",
    fontFamily: "TaleBlue, sans-serif",
    fontSize: "14px",
    cursor: "pointer",
    border: "none",
    outline: "none",
  };

  // to make inner child follow its parent's border radius
  const roundedClass = (className ?? "")
    .split(" ")
    .find((e) => e.startsWith("rounded-") || e.startsWith("!rounded-"));
  const formattedRoundedClass = !roundedClass
    ? ""
    : roundedClass?.startsWith("!")
    ? roundedClass
    : `!${roundedClass}`;  
  return (
    <Component
      className={`rounded-md transition-all flex items-center justify-center ${
        props.disabled
          ? "bg-[#ddd]"
          : resolvedRole === "business"
          ? "bg-tale-business"
          : "bg-tale-normal"
      } ${className} ${
        variant === "filled" ?"py-4 px-8 group relative overflow-hidden":"p-0.5"
      }`}
      onClick={loading ? () => undefined : onClick}
      style={buttonStyle}
      {...props}
    >
      {variant === "filled" && !props.disabled && (
        <div className="size-full opacity-0 invisible transition-all group-hover:opacity-100 group-hover:visible bg-black/20 absolute z-10" />
      )}
      <div
        className={`h-full w-full max-w-full rounded-md flex items-center justify-center font-semibold text-base transition-all duration-300 ${formattedRoundedClass} ${directParentClassName} ${
          variant === "filled" ? "z-20" : "bg-white hover:bg-[#FFFFFF99]"
        }`}
      >
        {loading ? (
          <TaleLoadingFallback
            circleProps={{
              size: loadingCircleSize,
              sx: { "svg circle": { stroke: "white" } },
            }}
          />
        ) : variant === "filled" ? (
          children
        ) : (
          <TaleText
            role={resolvedRole}
            className={`text-base px-4 ${
              props.disabled ? "!text-[#666]" : ""
            } ${directParentClassName ?? ""}`}
          >
            {children}
          </TaleText>
        )}
      </div>
    </Component>
  );
}

export default TaleButton;
